import * as angular from "angular";
import {VehicleType} from "../../commons/types/vehicle.type";
import {TravelTimeRuleModel} from "../models/travel-time-rule.model";

export class TravelTimeRuleRequestsService {

  /* @ngInject */
  constructor(private TravelTimeRuleAPI, private $travelTimeRule) {
  }

  getRules(vehicleType: VehicleType) {
    const api = this.TravelTimeRuleAPI.actions.getRules;
    return this.$$call(api, {}, {}, {vehicleType: vehicleType});
  }

  createRule(travelTimeRule: TravelTimeRuleModel) {
    const api = this.TravelTimeRuleAPI.actions.createRule;
    return this.$$call(api, {}, travelTimeRule, {});
  }

  updateRule(id: string, travelTimeRule: TravelTimeRuleModel) {
    const api = this.TravelTimeRuleAPI.actions.updateRule;
    return this.$$call(api, {}, travelTimeRule, {id: id});
  }

  deleteRule(id: string) {
    const api = this.TravelTimeRuleAPI.actions.deleteRule;
    return this.$$call(api, {}, {}, {id: id});
  }




  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$travelTimeRule().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .service('travelTimeRuleRequestsService', TravelTimeRuleRequestsService);
